import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { FetchSystemPromocodeService } from './system-promocode-mangement.service';
import { DeletePromocodeService } from './delete-promocode.service';
import paymentOptionsConstant from '../../../../../../shared/paymentOptionsConstant';
import { Report, RowActions } from '../../../../report/report';
import { AlertDialogComponent } from '../../../../../../shared/components/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-promocode-management',
  templateUrl: './promocode-management.component.html',
  styleUrls: ['./promocode-management.component.scss']
})
export class PromocodeManagementComponent implements OnInit {
  searchKey: string = '';
  Columns = [
    'codeName',
    'precentage',
    'maxPrecentageValue',
    'paymentOption',
    'availableQuantity',
    'redeemedQuantity',
    'createdAt',
    'expiry',
    "businessLimitQuantity"
  ];
  displayTableColumns = {
    'codeName': 'Promocode Name',
    'precentage': 'Percentage',
	'maxPrecentageValue': 'Max Value',
    'paymentOption': 'Payment Option',
    'availableQuantity': 'Total Quantity',
    'redeemedQuantity': 'Redeemed Quantity',
    'createdAt': 'Creation',
    'expiry': 'Expiry',
    'businessLimitQuantity':'Business Limit Quantity'
  };
  rowActions: RowActions[] = [
    {
      actionName: 'delete',
      actionType: 'icon',
      iconClass: 'fa-trash',
    },
    {
      actionName: 'edit',
      actionType: 'icon',
      iconClass: 'fa-edit',
    },
  ];

  filterField = [
    {
      filterFieldName: 'expired',
      filterDisplayName: 'Status',
      defaultValue: '',
      filterOptions: [
        { key: 'Show All', value: null },
        { key: 'Expired', value: 1 },
        { key: 'Not Expired', value: 0 },
      ]
    },
    {
      filterFieldName: "paymentOption",
      filterDisplayName: "Payment Options",
      defaultValue: "",
      filterOptions: [
        { key: "Show All", value: null },
        { key: paymentOptionsConstant.constantPaymentOptions.name.CREDIT_CARD, value: paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD },
        { key: paymentOptionsConstant.constantPaymentOptions.name.CASH, value: paymentOptionsConstant.constantPaymentOptions.value.CASH },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Mobile_Wallet, value: paymentOptionsConstant.constantPaymentOptions.value.Mobile_Wallet },
        { key: paymentOptionsConstant.constantPaymentOptions.name.MEEZA, value: paymentOptionsConstant.constantPaymentOptions.value.MEEZA },
        { key: paymentOptionsConstant.constantPaymentOptions.name.QASSATLY, value: paymentOptionsConstant.constantPaymentOptions.value.QASSATLY },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Fawry, value: paymentOptionsConstant.constantPaymentOptions.value.Fawry }      ]
    }
  ];
  totalNumberOfRecords = 0;
  systemPromocodeReportData: any[] = [];
  requestBody: Report = {};
  loading = false;

  constructor(
    public fetchSystemPromocodeService: FetchSystemPromocodeService,
    private deletePromocodeService: DeletePromocodeService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  async ngOnInit() {
    this.fetchSystemPromocodeService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.fetchSystemPromocodeService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.fetchSystemPromocodeService.loader().subscribe(val => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchSystemPromocodeService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchSystemPromocodeService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.fetchSystemPromocodeService.activateLoader();
    this.fetchSystemPromocodeService.setParams(this.requestBody);
    const report = await this.fetchSystemPromocodeService.make();
    this.systemPromocodeReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  onRowAction(event: any) {
    if (event.action === 'delete') {
      this.deletePromocode(event.key.id);
    }
    if (event.action === 'edit') {
      this.router.navigate(['/admin/actions/systemPromocode/edit/', event.key.codeName]);
    }
    if (event.action === 'copy') {
      this.copyInputMessage(event.key);
    }
  }

  async deletePromocode(id: number) {
    try {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: 'Are you sure you want to delete it',
          question: true
        }
      });
      const result = await dialogRef.afterClosed().toPromise();
      if (!result) {
        return;
      }
      this.deletePromocodeService.setParams({ id });
      await this.deletePromocodeService.make();
      this.updateTable();
      this.fetchSystemPromocodeService.loader().subscribe(val => (this.loading = val));
    } catch (err) {
      console.log(err);
    }
  }


  copyInputMessage(text: any) {
    let message = '';
    try {
      const selBox = document.createElement('textarea') as HTMLTextAreaElement;
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.select();
      const success = document.execCommand('copy');
      document.body.removeChild(selBox);
      message = success ? 'Link copied to clipboard' : 'Unable to copy link';
    } catch (err) {
      message = 'Unable to copy link';
    } finally {
      this.snackBar.open(message, '', { duration: 2000 });
    }
  }

}
